import { Link } from "react-router-dom";
import { useTranslation } from "../i18n/i18n";
import AppHeader from "../components/AppHeader/AppHeader";
import RegisterForm from "../components/AuthForm/RegisterForm";

const Register = () => {
	const { translate } = useTranslation();

	return (
		<div className="content auth-page-container legacy-auth">
			<AppHeader />
			<RegisterForm />
			<h2 className="application-description">
				{translate("register.haveAccount")}
			</h2>
			<Link to="/login" className="primary-button">
				{translate("register.loginLink")}
			</Link>
		</div>
	);
};

export default Register;
